import { supabase } from './supabaseClient';
import { Fornecedor } from './types';

// Fornecedores
export const getFornecedores = async () => {
    const { data, error } = await supabase.from('fornecedores').select('*').order('nome_razao_social');
    if (error) throw error;
    return data;
};

export const getFornecedorById = async (id: number) => {
    const { data, error } = await supabase.from('fornecedores').select('*').eq('id', id).single();
    if (error) throw error;
    return data;
};

export const addFornecedor = async (fornecedor: Omit<Fornecedor, 'id'>) => {
    const { data, error } = await supabase.from('fornecedores').insert([fornecedor]).select();
    if (error) throw error;
    return data;
};

export const updateFornecedor = async (id: number, fornecedor: Partial<Fornecedor>) => {
    const { data, error } = await supabase.from('fornecedores').update(fornecedor).eq('id', id).select();
    if (error) throw error;
    return data;
};

export const deleteFornecedor = async (id: number) => {
    const { error } = await supabase.from('fornecedores').delete().eq('id', id);
    if (error) throw error;
};

// Integração com BrasilAPI
export const consultarCNPJ = async (cnpj: string) => {
    const cleanCnpj = cnpj.replace(/\D/g, '');
    if (cleanCnpj.length !== 14) throw new Error('CNPJ inválido para consulta.');

    try {
        const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cleanCnpj}`);
        if (!response.ok) {
            throw new Error(`Erro na consulta do CNPJ: ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erro na requisição da BrasilAPI:', error);
        throw error;
    }
};
